import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Button, Dropdown, Menu, Avatar, Modal } from 'antd';
import {
  UserOutlined,
  CaretDownOutlined,
  HomeOutlined,
  LogoutOutlined,
} from '@ant-design/icons';
import logo from '../../assets/logos/haut.png';
import supermapLogo from '../../assets/logos/supermap.png';
import GISBg from '../gis-bg';
import styles from './style.less';

const { confirm } = Modal;

/**
 * 官网公共外壳：顶部导航（logo + 锚点导航 + 右上角登录/注册或用户中心）+ 内容 + 页脚
 * 登录态：localStorage 有 token + user 时，右上角显示「个人中心」下拉
 */
export default class PortalLayout extends Component {
  barRef = React.createRef();
  ticking = false;

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll, { passive: true });
    this.handleScroll(); // 初始化一次
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScroll);
  }

  // rAF 节流 + transform scaleX：不触发重排重绘，丝滑跟手
  handleScroll = () => {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      const bar = this.barRef.current;
      if (bar) {
        const doc = document.documentElement;
        const scrollTop = window.scrollY || doc.scrollTop;
        const max = doc.scrollHeight - doc.clientHeight;
        const progress = max > 0 ? Math.min(1, scrollTop / max) : 0;
        bar.style.transform = `scaleX(${progress})`;
      }
      this.ticking = false;
    });
  };

  getUser = () => {
    try {
      const token = window.localStorage.getItem('token');
      const user = JSON.parse(window.localStorage.getItem('user') || 'null');
      if (token && user && user.id) return user;
    } catch (e) {}
    return null;
  };

  handleLogout = () => {
    confirm({
      title: '您确定要退出登录吗？',
      onOk: () => {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('user');
        window.location.href = '/';
      },
    });
  };

  renderUserArea() {
    const user = this.getUser();
    if (!user) {
      return (
        <div className={styles.actions}>
          <Link to="/login">
            <Button className={styles['btn-login']}>登录</Button>
          </Link>
          <Link to="/register">
            <Button type="primary" className={styles['btn-register']}>
              注册报名
            </Button>
          </Link>
        </div>
      );
    }

    const menu = (
      <Menu className={styles['user-menu']}>
        <Menu.Item key="home" icon={<HomeOutlined />}>
          <Link to="/home/competition/all">进入个人中心</Link>
        </Menu.Item>
        <Menu.Item key="signup" icon={<UserOutlined />}>
          <Link to="/home/competition/my">我的报名</Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          key="logout"
          icon={<LogoutOutlined />}
          onClick={this.handleLogout}
        >
          退出登录
        </Menu.Item>
      </Menu>
    );

    return (
      <div className={styles.actions}>
        <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
          <div className={styles['user-chip']}>
            <Avatar
              size={30}
              icon={<UserOutlined />}
              className={styles['user-avatar']}
            >
              {user.name ? user.name.charAt(0) : null}
            </Avatar>
            <span className={styles['user-name']}>{user.name || '用户'}</span>
            <CaretDownOutlined className={styles['user-caret']} />
          </div>
        </Dropdown>
      </div>
    );
  }

  render() {
    const { children } = this.props;
    return (
      <div className={styles.portal}>
        <GISBg />
        {/* 顶部滚动进度条 */}
        <div className={styles['scroll-progress']} aria-hidden="true">
          <div ref={this.barRef} className={styles['scroll-progress-bar']} />
        </div>
        <header className={styles.navbar}>
          <Link to="/" className={styles.brand}>
            <img src={supermapLogo} alt="SuperMap 超图" className={styles['logo-supermap']} />
            <span className={styles['logo-divider']} />
            <img src={logo} alt="河南工业大学" className={styles['logo-haut']} />
            <div className={styles['brand-text']}>
              <span className={styles['brand-title']}>超图杯·校赛</span>
              <span className={styles['brand-sub']}>SuperMap GIS Competition</span>
            </div>
          </Link>
          <nav className={styles.nav}>
            <NavLink exact to="/" activeClassName={styles.active}>
              首页
            </NavLink>
            <NavLink to="/portal/competition" activeClassName={styles.active}>
              赛事中心
            </NavLink>
            <NavLink to="/portal/team-board" activeClassName={styles.active}>
              组队求助
            </NavLink>
          </nav>
          {this.renderUserArea()}
        </header>
        <main className={styles.main}>{children}</main>
        <footer className={styles.footer}>
          <div className={styles['footer-inner']}>
            <span className={styles['footer-brand']}>
              <img src={supermapLogo} alt="SuperMap 超图" />
              超图杯 · 河南工业大学校赛报名系统
            </span>
            <span className={styles['footer-dim']}>
              主办方：河南工业大学 · 技术支持：超图软件 SuperMap GIS
            </span>
          </div>
        </footer>
      </div>
    );
  }
}
